import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getGoogleClientId } from '../utils/apiConfig';

interface GoogleAuthProviderProps {
    children: React.ReactNode;
}

export function GoogleAuthProvider({ children }: GoogleAuthProviderProps) {
    const clientId = getGoogleClientId();
    
    // Log the client ID status for debugging
    React.useEffect(() => {
        if (!clientId) {
            console.warn('[PAIR-APP] Google Client ID not configured');
        } else {
            console.log('[PAIR-APP] Google OAuth Provider initialized with client ID:', clientId.substring(0, 10) + '...');
            console.log('[PAIR-APP] Full Client ID:', clientId);
        }
    }, [clientId]);
    
    // If no client ID is configured, just render children without the provider
    if (!clientId) {
        return <>{children}</>;
    }
    
    return (
        <GoogleOAuthProvider clientId={clientId}>
            {children}
        </GoogleOAuthProvider>
    );
}